import { render, staticRenderFns } from "./vehicleRepairList.vue?vue&type=template&id=b2729950&scoped=true"
import script from "./vehicleRepairList.vue?vue&type=script&lang=js"
export * from "./vehicleRepairList.vue?vue&type=script&lang=js"
import style0 from "./vehicleRepairList.vue?vue&type=style&index=0&id=b2729950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2729950",
  null
  
)

export default component.exports